import { Link, useLocation } from 'react-router-dom';
import { SxProps, Box, Typography } from '@mui/material';
import { routes, NavItem } from '../constants';

/**
 * Navigation bar component
 * 
 * @returns Navigation bar element
 */
export const NavBar = (): JSX.Element => {
	const { pathname } = useLocation();
	
	const navTopItems: NavItem[] = [
		routes.ClientHistory,
		routes.PredictedDiagnoses,
		routes.ConfirmationTests,
	];

	const navBotItems: NavItem[] = [
		routes.DsmAssociations,
		routes.DsmReference,
	];

	const containerStyle: SxProps = {
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		borderRight: '#eef2f8 2px solid',
	};

	const topSectionStyle: SxProps = {
		display: 'flex',
		flexDirection: 'column',
	};

	const bottomSectionStyle: SxProps = {
		display: 'flex',
		flexDirection: 'column',
		marginTop: 'auto',
	};

	const buttonStyle: SxProps = {
		borderLeft: '#eef2f8 1px solid',
		borderTop: '#eef2f8 1px solid',
		borderBottom: '#eef2f8 1px solid',
		color: '#eef2f8',
		textDecoration: 'none',
	};

	const linkResetStyle: SxProps = {
		textDecoration: 'none',
		color: 'inherit',
		display: 'block',
	}

	const textStyle: SxProps = {
		fontSize: '20pt',
		padding: '15px',
	};

	const selectedStyle: SxProps = {
		backgroundColor: '#3a86ff',
	}

	const renderButton = (navItem: NavItem): JSX.Element => (
		<Box key={navItem.path()} sx={buttonStyle}>
			<Box component={Link} to={navItem.path()} sx={linkResetStyle}>
				<Typography sx={{ ...textStyle, ...navItem.path() === pathname ? selectedStyle : {} }}>
					{navItem.title}
				</Typography>
			</Box>
		</Box>
	);

	return (
		<Box sx={containerStyle}>
			<Box sx={topSectionStyle}>
				{navTopItems.map((navItem) => renderButton(navItem))}
			</Box>
			<Box sx={bottomSectionStyle}>
				{navBotItems.map((navItem) => renderButton(navItem))}
			</Box>
		</Box>
	);
};
	
export default NavBar;



	

// 	const navBarItemsContainer: CSSProperties = {
// 		display: 'inline',
// 		// width: '20%',
// 		height: '100%',
// 		fontSize: '9pt',
// 		padding: 0,
// 		borderRight: '#eef2f8 1px solid',
// 		left: 0,
// 	};

// 	const navBarBottomDiv: CSSProperties = {
// 	  position: 'fixed',
// 	  // width: '20%',
// 	  bottom: 0,
// 	};

// 	const navTextDiv: CSSProperties = {
// 		borderBottom: '#eef2f8 1px solid',
// 	};

// 	const navBottomText: CSSProperties = {
// 		borderTop: '#eef2f8 1px solid',
// 		borderBottom: 'none',
// 	};

// 	const navBarItem: CSSProperties = {
// 		textDecoration: 'none',
// 		color: '#eef2f8',
// 		// padding: '15px',
// 		// margin: 0,
// 	};

// 	const selectedNavItemText: CSSProperties = {
// 		backgroundColor: '#3a86ff',
// 		padding: '15px',
// 		margin: 0,
// 	};

// 	const navBarItemText: CSSProperties = {
// 		padding: '15px',
// 		margin: 0,
// 	};



// 	/**
// 	 * Renders a navigation item
// 	 * 
// 	 * @param navItem Navigation item to render
// 	 * @param bottom Whether the navigation item should be rendered at the bottom of the navigation bar
// 	 * @returns Navigation item element
// 	 */
// 	const renderNavItem = (navItem: NavItem, bottom: boolean = false): JSX.Element => (
//     <div
//       // className={`navTextDiv${bottom ? ' navBottomText' : ''}`}
// 			style={{...navTextDiv, ...bottom ? navBottomText : {}}}
//       key={`navBarItem-${navItem.path()}`}
//     >
//       <Link to={navItem.path()} style={navBarItem}>
//         <h1 style={navItem.path() === pathname ? selectedNavItemText : navBarItemText}>
//           {navItem.title}
//         </h1>
//       </Link>
//     </div>
//   );

// 	return (
// 		<div style={navBarItemsContainer}>
// 			<div>
// 				{navTopItems.map((navItem) => renderNavItem(navItem, false))}
// 			</div>
// 			<div style={navBarBottomDiv}>
// 				{navBotItems.map((navItem) => renderNavItem(navItem, true))}
// 			</div>
// 		</div>
// 	)
// };
